export { default } from './BrowserUpgrade';
